import { SR_API_ACTION_GET_ASSIGNED_HOUSEHOLD_ADMIN_BY_PHONE } from 'api/actionTypes';

export default async function getAssignedHouseholdAdminByPhone({ state, apiClient }, phone) {
  const result = await apiClient.postWithState({
    action: SR_API_ACTION_GET_ASSIGNED_HOUSEHOLD_ADMIN_BY_PHONE,
    state: state,
    payload: {
      phone: phone,
    },
    onSuccess(householdAdminUserId) {
      state.set(['admin', 'userHouseholdAdminUserId'], householdAdminUserId || null);
      return householdAdminUserId;
    },
  });

  return result;
}
